interface HelpArticleVisibilityFields {
	hideInProd?: boolean;
}

interface HelpArticleVisibilityOptions {
	preview?: boolean;
	production?: boolean;
}

export const isHelpArticleVisible = (
	fields: HelpArticleVisibilityFields | null | undefined,
	{
		preview = false,
		production = process.env.NODE_ENV === "production",
	}: HelpArticleVisibilityOptions = {},
): boolean => !production || preview || fields?.hideInProd !== true;